import { createApi } from '@reduxjs/toolkit/query/react';
import { IPaymentHistoryItem } from 'src/models/paymentsHistory';
import { PagListResult } from 'src/models/types';
import { baseQuery } from 'src/utils/baseQuery';

export const paymentsHistoryApi = createApi({
  reducerPath: 'paymentsHistory',
  baseQuery,
  tagTypes: ['PaymentsHistory'],
  endpoints: (builder) => ({
    getPaymentsHistory: builder.query<PagListResult<IPaymentHistoryItem>, any>({
      query: (params) => ({
        url: '/subscriptions/payment-history',
        params,
      }),
      providesTags: ['PaymentsHistory'],
    }),
  }),
});

export const { useGetPaymentsHistoryQuery } = paymentsHistoryApi;
